import React, { Component } from 'react';

import PropTypes from 'prop-types';
import Icon from 'react-icon-base';

export default class StaticIcon extends Component {
  static propTypes = {
    /**
     * Icon size
     */
    size: PropTypes.number,
    /**
     * Icon type
     */
    type: PropTypes.oneOf([
      'account',
      'avatar',
      'bag',
      'calendar',
      'caret',
      'chatbox',
      'check',
      'clock',
      'close',
      'computer',
      'delivery',
      'eye',
      'eyeCrossedOut',
      'filters',
      'gift',
      'heartFilled',
      'heartUnfilled',
      'lock',
      'menu',
      'phone',
      'piggyBank',
      'plus',
      'print',
      'search',
      'starFilled',
      'starHalfFilled',
      'starUnfilled',
      'underwear',
    ]).isRequired,
  };

  VIEWBOX = {
    account: '0 0 14 20',
    avatar: '0 0 25 25',
    bag: '0 0 44 50',
    calendar: '0 0 40 40',
    caret: '0 0 8 5',
    chatbox: '0 0 24 22',
    check: '0 0 12 10',
    clock: '0 0 48 48',
    close: '0 0 20 19',
    computer: '0 0 24 16',
    delivery: '0 0 57 36',
    eye: '0 0 16 10',
    eyeCrossedOut: '0 0 16 13',
    filters: '0 0 17 15',
    gift: '0 0 45 44',
    heartFilled: '0 0 20 18',
    heartUnfilled: '0 0 24 21',
    lock: '0 0 40 40',
    menu: '0 0 18 14',
    phone: '0 0 14 24',
    piggyBank: '0 0 32.88 25.99',
    plus: '0 0 12 13',
    print: '0 0 16 16',
    search: '0 0 24 24',
    starFilled: '0 0 14 14',
    starHalfFilled: '0 0 14 14',
    starUnfilled: '0 0 14 14',
    underwear: '0 0 40 40',
  };

  renderPaths(type) {
    switch (type) {
      case 'account':
        return (
          <g xmlns="http://www.w3.org/2000/svg" fill="none" fillRule="evenodd">
            <path
              fill="currentColor"
              d="M12.5 12.5h-11V20H0v-9h14v9h-1.5v-7.5z"
            />
            <circle
              cx="7"
              cy="5"
              r="4.25"
              stroke="currentColor"
              strokeWidth="1.5"
            />
          </g>
        );
      case 'avatar':
        return (
          <g xmlns="http://www.w3.org/2000/svg" fill="none" fillRule="evenodd">
            <circle cx="12.5" cy="12.5" r="12" stroke="currentColor" />
            <path
              d="m6.5 19.866c-2.136-1.742-3.5-4.3946-3.5-7.3658 0-5.2467 4.2533-9.5 9.5-9.5 5.2467 0 9.5 4.2533 9.5 9.5 0 2.9712-1.364 5.6238-3.5 7.3658v-5.3658h-12v5.3658zm6-6.3658c2.2091 0 4-1.7909 4-4s-1.7909-4-4-4-4 1.7909-4 4 1.7909 4 4 4z"
              fill="currentColor"
            />
          </g>
        );
      case 'calendar':
        return (
          <g>
            <path
              d="M22.863 31.5H7.923C6.861 31.5 6 30.746 6 29.816V13h25v9.453"
              strokeLinecap="round"
              fill="none"
              stroke="currentColor"
            />
            <path d="M23.5 9.5V11a1.5 1.5 0 0 0 3 0V9.5h3a2 2 0 0 1 2 2v2h-26v-2a2 2 0 0 1 2-2h3V11a1.5 1.5 0 0 0 1.356 1.493L12 12.5a1.5 1.5 0 0 0 1.5-1.5V9.5h10z" />
            <g>
              <path
                d="M10.5 16.5h2v2h-2zM15.5 16.5h2v2h-2zM20.5 16.5h2v2h-2zM25.5 16.5h2v2h-2z"
                fillRule="evenodd"
                clipRule="evenodd"
              />
            </g>
            <g>
              <path
                d="M10.5 20.5h2v2h-2zM15.5 20.5h2v2h-2zM20.5 20.5h2v2h-2zM25.5 20.5h2v2h-2z"
                fillRule="evenodd"
                clipRule="evenodd"
              />
            </g>
            <g>
              <path
                d="M10.5 24.5h2v2h-2zM15.5 24.5h2v2h-2zM20.5 24.5h2v2h-2z"
                fillRule="evenodd"
                clipRule="evenodd"
              />
            </g>
            <path
              d="M25 8v3M12 8v3"
              strokeLinecap="round"
              fill="none"
              stroke="currentColor"
            />
            <path d="M24.25 33.25c0 .415.335.75.75.75h3.75v-3.75h-4.5v3zm6 .75H34a.75.75 0 0 0 .75-.75v-3h-4.5V34zm4.5-7.5h-.987c.146-.284.237-.598.237-.938a2.066 2.066 0 0 0-2.063-2.062c-.975 0-1.605.5-2.414 1.6-.808-1.1-1.439-1.6-2.414-1.6a2.066 2.066 0 0 0-2.062 2.062c0 .34.089.654.237.938H24.25a.75.75 0 0 0-.75.75v1.875c0 .206.169.375.375.375h11.25a.376.376 0 0 0 .375-.375V27.25a.75.75 0 0 0-.75-.75zm-7.643 0a.937.937 0 1 1 0-1.875l.102.002c.42.019.798.208 1.916 1.873h-2.018zm4.83 0H29.92c1.204-1.793 1.54-1.875 2.017-1.875a.937.937 0 1 1 0 1.875z" />
          </g>
        );
      case 'caret': {
        const strokeWidth = this.props.size > 20 ? '0' : '1';
        return (
          <path
            fill="currentColor"
            stroke="currentColor"
            strokeLinecap="butt"
            strokeWidth={strokeWidth}
            d="M7.5,1.02,4,4.52.5,1.02,1.04.48,3.777,3.217,4,3.44l.223-.223L6.96.48Z"
          />
        );
      }
      case 'check':
        return (
          <path
            xmlns="http://www.w3.org/2000/svg"
            fillRule="evenodd"
            d="M3.89 7.546L10.606.828l1.06 1.061L3.89 9.667 0 5.778l1.06-1.06z"
          />
        );
      case 'chatbox':
        return (
          <path
            fill="currentColor"
            fillRule="nonzero"
            d="M24 0H0v16.981h4V22l7-5.019h13z"
          />
        );
      case 'close':
        return (
          <g
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            fillRule="evenodd"
          >
            <path d="M2.224.3l16.97 16.97-1.413 1.414L.81 1.714z" />
            <path d="M.81 17.27L17.78.3l1.414 1.414-16.97 16.97z" />
          </g>
        );
      case 'computer':
        return (
          <path
            fill="currentColor"
            d="M22,13V1.2A1.2,1.2,0,0,0,20.8,0H3.2A1.2,1.2,0,0,0,2,1.2H2V13ZM4,2H20v9H4ZM24,14v.8A1.2,1.2,0,0,1,22.8,16H1.2A1.2,1.2,0,0,1,0,14.8V14H10a.5.5,0,0,0,.5.5h3A.5.5,0,0,0,14,14Z"
          />
        );
      case 'eye':
        return (
          <path d="M8.01 1.333c3.167 0 5.375 2.008 6.336 3.091C13.412 5.649 11.204 8 8.01 8 5.063 8 2.723 5.643 1.691 4.395c.996-1.098 3.212-3.062 6.319-3.062zM8.01 0C2.964 0 0 4.367 0 4.367s3.223 4.966 8.01 4.966c5.155 0 7.99-4.966 7.99-4.966S13.14 0 8.01 0zM8 2a2.667 2.667 0 1 0 .001 5.334A2.667 2.667 0 0 0 8 2z" />
        );
      case 'eyeCrossedOut':
        return (
          <path d="M13.07.375l-2.231 2.091A8.81 8.81 0 0 0 8.01 2C2.964 2 0 6.367 0 6.367s1.285 1.968 3.43 3.426l-1.94 1.939.943.943 11.58-11.357-.944-.943zM9.058 4.227C6.867 3.26 4.605 5.5 5.549 7.698L4.398 8.836c-1.21-.773-2.15-1.767-2.707-2.44.996-1.099 3.212-3.063 6.319-3.063a7.4 7.4 0 0 1 1.74.21l-.691.684zM7.137 9.181l3.393-3.328c.678 2.074-1.335 4.044-3.393 3.328zM16 6.367s-2.835 4.966-7.99 4.966c-.92 0-1.775-.194-2.567-.491l1.076-1.055c.476.128.972.213 1.491.213 3.194 0 5.403-2.351 6.336-3.576a10.206 10.206 0 0 0-2.391-1.968l.992-.973C14.935 4.749 16 6.367 16 6.367z" />
        );
      case 'filters':
        return (
          <g fill="none" fillRule="evenodd">
            <path
              fill="currentColor"
              fillRule="nonzero"
              d="M9.68 3c.27 0 .49.224.49.5s-.22.5-.49.5H1.66a.495.495 0 0 1-.49-.5c0-.276.22-.5.49-.5h8.02zm5.835 0c.271 0 .491.224.491.5s-.22.5-.49.5h-2.294a.495.495 0 0 1-.49-.5c0-.276.219-.5.49-.5h2.293z"
            />
            <circle cx="11.498" cy="3.502" r="1.5" stroke="currentColor" />
            <path
              fill="currentColor"
              fillRule="nonzero"
              d="M9.68 11c.27 0 .49.224.49.5s-.22.5-.49.5H1.66a.495.495 0 0 1-.49-.5c0-.276.22-.5.49-.5h8.02zm5.835 0c.271 0 .491.224.491.5s-.22.5-.49.5h-2.294a.495.495 0 0 1-.49-.5c0-.276.219-.5.49-.5h2.293z"
            />
            <circle cx="11.498" cy="11.502" r="1.5" stroke="currentColor" />
            <path
              fill="currentColor"
              fillRule="nonzero"
              d="M7.497 7a.495.495 0 0 0-.49.5c0 .276.219.5.49.5h8.018c.271 0 .491-.224.491-.5s-.22-.5-.49-.5h-8.02zM1.66 7a.495.495 0 0 0-.491.5c0 .276.22.5.49.5h2.294c.271 0 .49-.224.49-.5s-.219-.5-.49-.5H1.661z"
            />
            <circle
              cx="5.5"
              cy="7.502"
              r="1.5"
              stroke="currentColor"
              transform="matrix(-1 0 0 1 11 0)"
            />
          </g>
        );
      case 'heartFilled':
        return (
          <path d="M10.883 17.611l7.559-8.027c2.199-2.335 2.07-6.2-.383-8.353-2.14-1.877-5.324-1.539-7.29.546L10 2.593l-.77-.816C7.27-.308 4.083-.646 1.943 1.231-.511 3.384-.64 7.249 1.555 9.584l7.559 8.027c.488.519 1.28.519 1.77 0z" />
        );
      case 'heartUnfilled':
        return (
          <path d="M11.995 21c.385 0 .769-.15 1.06-.455l9.07-9.365c2.644-2.719 2.489-7.228-.455-9.74-2.554-2.176-6.375-1.815-8.747.632L12 3.028l-.923-.951C9.164.098 5.307-1.093 2.33 1.439-.614 3.952-.77 8.461 1.866 11.18l9.07 9.366c.29.3.675.455 1.06.455zm.024-1.495l-9.075-9.366c-1.8-1.856-2.175-5.395.36-7.556 2.57-2.194 5.588-.605 6.694.539L12 5.189l2.002-2.067c1.087-1.125 4.134-2.719 6.693-.54 2.532 2.157 2.161 5.696.361 7.557l-9.037 9.366z" />
        );
      case 'lock':
        return (
          <path
            fill="currentColor"
            d="m14.1 17.1h11.5v-4.2q0-2.4-1.7-4.1t-4-1.7-4.1 1.7-1.7 4.1v4.2z m18.6 2.2v12.8q0 0.9-0.6 1.6t-1.5 0.6h-21.5q-0.8 0-1.5-0.6t-0.6-1.6v-12.8q0-0.9 0.6-1.5t1.5-0.7h0.8v-4.2q0-4.1 2.9-7.1t7.1-2.9 7 2.9 3 7.1v4.2h0.7q0.9 0 1.5 0.7t0.6 1.5z"
          />
        );
      case 'menu':
        return (
          <path
            fillRule="evenodd"
            fill="currentColor"
            d="M17.883 2.297c.272 0 .492-.22.492-.492V.492c0-.272-.22-.492-.492-.492H.493C.22 0 0 .22 0 .492v1.313c0 .271.22.492.492.492h17.39zm0 6.562c.272 0 .492-.22.492-.492V7.055c0-.272-.22-.493-.492-.493H.493c-.273 0-.493.22-.493.493v1.312c0 .272.22.492.492.492h17.39zm0 6.563c.272 0 .492-.22.492-.492v-1.313c0-.272-.22-.492-.492-.492H.493c-.273 0-.493.22-.493.492v1.313c0 .271.22.492.492.492h17.39z"
          />
        );
      case 'piggyBank':
        return (
          <g>
            <path
              d="M22.88,8.5v-3l-2.21,2h-0.79 M6.88,8.5v-3l2.21,2h0.82"
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M18.21,9.22c2.06-1.84,2.23-5.01,0.38-7.06s-5.01-2.23-7.06-0.38s-2.23,5.01-0.38,7.06 c0.12,0.13,0.24,0.26,0.38,0.38"
              fill="none"
              stroke="currentColor"
            />
            <path
              d="M10.38,9.22h9.5"
              fill="none"
              stroke="currentColor"
              strokeWidth="0.8"
              strokeLinecap="round"
            />
            <path
              d="M11.84,24.22h6"
              fill="none"
              stroke="currentColor"
              strokeLinecap="square"
            />
            <path
              d="M18.53,23.83c-0.01,1.18,0.14,1.94,0.45,2.3c0.47,0.53,2.26,0.38,2.65,0.22c0.4-0.16,0.34-1.45,0.34-1.84
        		s1.16-1.3,1.91-1.82c1.78-1.24,2.99-3.77,2.99-6.68c0-3.43-1.69-6.32-3.99-7.22 M11.28,23.83c0.01,1.18-0.14,1.94-0.45,2.3
        		c-0.47,0.53-2.26,0.38-2.65,0.22c-0.4-0.16-0.34-1.45-0.34-1.84s-1.18-1.22-1.91-1.82C4.35,21.39,3.39,20,2.94,17.27
        		c-0.04-0.23-2.11-0.45-2.32-0.83c-0.21-0.38-0.11-2.6,0.16-2.95c0.24-0.31,2.44,0.02,2.61-0.51c0.65-2.02,1.95-3.58,3.53-4.19"
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
            />
            <path
              d="M26.88,16.85c1.05,1.15,2.13,1.79,3.24,1.94c1.65,0.21,3.26-1,3.26-2.42s-0.95-1.94-1.78-1.94
        		c-0.83,0-1.44,0.92-1.23,1.41"
              fill="none"
              stroke="currentColor"
            />
            <path
              d="M15.4,8.02h-0.71V7.27c-0.97-0.13-1.43-0.84-1.5-1.43l0.87-0.21c0.04,0.44,0.34,0.85,0.98,0.85
        		c0.45,0,0.72-0.22,0.72-0.52c0-0.24-0.17-0.42-0.52-0.5l-0.64-0.14c-0.76-0.17-1.23-0.64-1.23-1.32c0-0.74,0.57-1.29,1.32-1.41
        		V1.84h0.71v0.77c0.81,0.15,1.16,0.71,1.25,1.18l-0.86,0.24c-0.04-0.24-0.22-0.65-0.8-0.65c-0.45,0-0.69,0.26-0.69,0.55
        		c0,0.22,0.15,0.4,0.48,0.47l0.64,0.15c0.88,0.2,1.28,0.72,1.28,1.35c0,0.64-0.46,1.24-1.3,1.37C15.4,7.26,15.4,8.02,15.4,8.02z"
              fillRule="evenodd"
              clipRule="evenodd"
            />
            <path
              d="M6.9,12.94C6.9,12.59,7,12.28,7.22,12s0.5-0.44,0.85-0.49"
              fill="none"
              stroke="currentColor"
              strokeWidth="0.8"
              strokeLinecap="round"
            />
          </g>
        );
      case 'phone':
        return (
          <path
            fill="currentColor"
            fillRule="nonzero"
            d="M14 2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V2zM5.5 2h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1zM7 22a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm5-3H2V4.976h10V19z"
          />
        );
      case 'plus':
        return (
          <path
            fill="currentColor"
            fillRule="evenodd"
            xmlns="http://www.w3.org/2000/svg"
            d="M0 5.382h4.91V0h2.153v5.382H12v2.18H7.063V13H4.91V7.563H0z"
          />
        );
      case 'print':
        return (
          <path
            fill="currentColor"
            fillRule="nonzero"
            d="M9.333 13.333h-4v-.666h4v.666zm6.667-10V12h-2.667v4H2.667v-4H0V3.333h2.667V0h10.666v3.333H16zM12 10H4v4.667h8V10zm0-8.667H4v2h8v-2zM14.667 5A.333.333 0 1 0 14 5a.333.333 0 0 0 .667 0zm-4 6.333H5.333V12h5.334v-.667z"
          />
        );
      case 'search':
        return (
          <path
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            fillRule="evenodd"
            d="M23.372 23.836l.464-.464c.22-.22.22-.577 0-.797l-6.047-6.047c-.108-.108-.248-.164-.398-.164h-.483c1.608-1.739 2.592-4.06 2.592-6.614C19.5 4.364 15.136 0 9.75 0S0 4.364 0 9.75s4.364 9.75 9.75 9.75c2.555 0 4.875-.984 6.614-2.588v.479c0 .15.061.29.164.398l6.047 6.047c.22.22.577.22.797 0zM9.75 18C5.19 18 1.5 14.31 1.5 9.75c0-4.56 3.69-8.25 8.25-8.25C14.31 1.5 18 5.19 18 9.75 18 14.31 14.31 18 9.75 18z"
          />
        );
      case 'starFilled':
        return (
          <path
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            fillRule="nonzero"
            d="M7 0l1.653 5.085H14L9.673 8.23l1.653 5.086L7 10.172l-4.327 3.143 1.653-5.086L0 5.086h5.347z"
          />
        );
      case 'starUnfilled':
        return (
          <path
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            fillRule="nonzero"
            stroke="currentColor"
            d="M7 1.618L5.71 5.585H1.54l3.375 2.453-1.29 3.968L7 9.554l3.375 2.452-1.29-3.968 3.376-2.453H8.29L7 1.618z"
          />
        );
      case 'starHalfFilled':
        return (
          <>
            <defs key={1}>
              <path
                id="star-half-filled-mask-1"
                d="M7 0l1.653 5.085H14L9.673 8.23l1.653 5.086L7 10.172l-4.327 3.143 1.653-5.086L0 5.086h5.347z"
              />
            </defs>
            ,
            <g fill="none" fillRule="evenodd" key={2}>
              <mask id="star-half-filled-mask-2" fill="#fff">
                <use xlinkHref="#star-half-filled-mask-1" />
              </mask>
              <path
                stroke="currentColor"
                d="M7 1.618L5.71 5.585H1.54l3.375 2.453-1.29 3.968L7 9.554l3.375 2.452-1.29-3.968 3.376-2.453H8.29L7 1.618z"
              />
              <path
                fill="currentColor"
                d="M0 0h7v13H0z"
                mask="url(#star-half-filled-mask-2)"
              />
            </g>
          </>
        );
      case 'bag':
        return (
          <path
            fill="currentColor"
            d="M39.668,10.214a0.913,0.913,0,0,0-.91-0.827H32.39V7.313A7.3,7.3,0,0,0,22.458.493a7.3,7.3,0,0,0-9.934,6.82V9.387H5.273a0.915,0.915,0,0,0-.91.81L0.006,48.192a0.915,0.915,0,0,0,.91,1.02H38.758l0.009,0h3.712a0.912,0.912,0,0,0,.911-1.005ZM25.076,1.833a5.488,5.488,0,0,1,5.482,5.48V9.386H27.15V7.313a7.291,7.291,0,0,0-2.464-5.46C24.815,1.844,24.944,1.833,25.076,1.833ZM22.457,2.5a5.485,5.485,0,0,1,2.862,4.812V9.386H19.595V7.313A5.487,5.487,0,0,1,22.457,2.5Zm-8.1,4.812a5.487,5.487,0,0,1,5.482-5.48c0.132,0,.261.011,0.39,0.02a7.29,7.29,0,0,0-2.465,5.46V9.386H14.356V7.313ZM1.943,47.379l4.146-36.16h6.435V15.77a0.916,0.916,0,0,0,1.832,0V11.219H25.319V15.77a0.915,0.915,0,1,0,1.831,0V11.218h6.883l3.71,36.16H1.943Zm37.641,0-3.71-36.161h2.053L41.469,47.38H39.584Z"
          />
        );
      case 'gift':
        return (
          <path
            fill="currentColor"
            d="M44,10.419a8.294,8.294,0,0,0-1.093-.336,6.845,6.845,0,0,0-1.514-.021A17.176,17.176,0,0,0,42.858,6.4,5.44,5.44,0,0,0,36.036.156a20.792,20.792,0,0,0-5.3,2.106,27.5,27.5,0,0,0-4.37,3.089c-1.341,1.107-2.539,2.389-3.925,3.713-0.233-.253-0.511-0.558-0.793-0.858a28.672,28.672,0,0,0-9.733-7.154A13.247,13.247,0,0,0,7.639.062,4.907,4.907,0,0,0,2.781,2.778a5.64,5.64,0,0,0,.1,5.761c0.257,0.448.586,0.855,1.052,1.525-0.918,0-1.666.005-2.413,0a1.3,1.3,0,0,0-1.513,1.5c0.011,3.408.2,6.82,0,10.223-0.091,1.56.8,1.7,2.07,1.706v1.423c0,5.957-.017,11.915.024,17.871A1,1,0,0,0,2.632,44H42.384a1.039,1.039,0,0,0,.542-1.206c0.043-5.944.025-11.885,0.025-17.828v-1.22l1.105-.46A1.54,1.54,0,0,0,45,21.866v-10A1.544,1.544,0,0,0,44,10.419ZM7.673,2.235a5.474,5.474,0,0,1,1.545.21C13.58,3.789,17,6.525,20.363,10.059c-4.064,0-7.755.034-11.431-.011a5.2,5.2,0,0,1-4.3-2.74C3.435,4.609,5.069,2.215,7.673,2.235ZM2.281,21.208h0V12.385H21.338v8.823H2.281ZM21.35,42.469H4.334V23.53H21.35V42.469Zm3.3-32.408a26.94,26.94,0,0,1,10.43-7.4,7.324,7.324,0,0,1,1.261-.314c2.034-.343,3.435.252,4.09,1.72A3.7,3.7,0,0,1,39.2,8.623,5.387,5.387,0,0,1,35.311,10.1c-3.421-.123-6.85-0.038-10.66-0.038h0ZM40.691,42.412H23.651V23.542h17.04v18.87Zm2.053-21.234H23.661v-8.8H42.744v8.8Z"
          />
        );
      case 'delivery':
        return (
          <path
            fill="currentColor"
            d="M45.933,33.154a2.55,2.55,0,1,0-2.522-2.523A2.568,2.568,0,0,0,45.933,33.154Zm-30.616,0a2.55,2.55,0,1,0-2.524-2.522A2.595,2.595,0,0,0,15.317,33.154ZM52.28,15.23c-1.91-2.539-3.666-4.886-5.446-7.215A0.929,0.929,0,0,0,46.187,7.7C43.6,7.681,41.02,7.689,38.371,7.689V15.23H52.28ZM53.5,17.947H38.37v9.977c1.644,0.171,3.011.322,4.334-1.1a4.5,4.5,0,0,1,6.478,0c1.322,1.441,2.7,1.21,4.314,1.15V17.946h0ZM35.644,28.028V2.646H2.711v25.32c0.45,0.026.8,0.064,1.146,0.065,2.141,0,4.285.04,6.424-.033a2.158,2.158,0,0,0,1.221-.72,5.1,5.1,0,0,1,7.705.057A1.9,1.9,0,0,0,20.3,28c5.09,0.044,10.181.03,15.35,0.03h0Zm20.62-11.7V29.8c-1.45,1.528-3.4.471-5.045,0.957-0.993,3.377-2.462,4.858-5,4.905-3.343.062-4.912-1.952-5.5-4.96H20.625c-1.038,3.45-2.484,4.87-5.018,4.97-2.748.11-4.1-1.08-5.634-5.034-2.613,0-5.263.013-7.91,0C0.38,30.622.015,30.246,0.006,28.54c-0.014-2.857,0-5.712,0-8.569q0-8.949,0-17.9c0-1.753.3-2.049,2.057-2.05C13.488,0.015,24.912.035,36.336,0c1.472,0,2.045.573,1.951,2.005-0.062.953-.012,1.913-0.012,3.067,2.795,0,5.434-.083,8.062.05A3.432,3.432,0,0,1,48.628,6.2C51.249,9.515,53.734,12.94,56.264,16.326Z"
          />
        );
      case 'clock':
        return (
          <path
            fill="currentColor"
            d="M22.5,0.375A22.125,22.125,0,1,0,44.625,22.5,22.15,22.15,0,0,0,22.5.375Zm0,41.25A19.125,19.125,0,1,1,41.625,22.5,19.147,19.147,0,0,1,22.5,41.625Zm12.685-14a1.5,1.5,0,0,1-1.434,1.063,1.476,1.476,0,0,1-.437-0.065L23,25.483a1.5,1.5,0,0,1-1.063-1.435V10.313a1.5,1.5,0,0,1,3,0V22.938l9.249,2.815A1.5,1.5,0,0,1,35.185,27.624Z"
          />
        );
      case 'underwear':
        return (
          <g>
            <path
              d="M9.885 30.305v-.522l.225-2.583c3.023.48 6.479.72 10.367.72 3.888 0 7.344-.24 10.367-.72l.271 2.583v.86c-2.424.67-4.327 1.531-5.71 2.585-1.384 1.053-2.336 2.488-2.859 4.305-.511.311-1.193.467-2.046.467-.853 0-1.535-.156-2.046-.467-.434-1.83-1.289-3.263-2.566-4.3s-3.278-2.013-6.003-2.928z"
              fill="none"
              stroke="currentColor"
              strokeLinecap="square"
              strokeLinejoin="round"
            />
            <path
              d="M14.383 2v8.603c-.331.77-.993 1.545-1.984 2.325A8.856 8.856 0 0 1 9 14.568l1.073 5.174c.76-.181 1.35-.25 1.773-.209 2.086.209 3.914.467 4.472.467M26.617 2v8.603c.331.77.993 1.545 1.984 2.325A8.856 8.856 0 0 0 32 14.568l-1.073 5.174c-.76-.181-1.35-.25-1.773-.209-2.086.209-3.914.467-4.472.467"
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M14.278 10.47c.208.48.637.899 1.287 1.258.973.54 2.286 1.21 3.374 2.148a5.248 5.248 0 0 1 1.561 2.31"
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
            />
            <path
              d="M16.164 20c-1.542 0-2.897-.68-3.68-1.71a3.401 3.401 0 0 1-.26-.404"
              fill="none"
              strokeWidth="0.8"
              stroke="currentColor"
              strokeLinecap="round"
            />
            <path
              d="M26.722 10.47c-.208.48-.637.899-1.287 1.258-.973.54-2.286 1.21-3.374 2.148a5.248 5.248 0 0 0-1.561 2.31"
              fill="none"
              stroke="currentColor"
            />
            <path
              d="M24.836 20c1.542 0 2.897-.68 3.68-1.71a3.35 3.35 0 0 0 .245-.38"
              fill="none"
              stroke="currentColor"
              strokeWidth="0.8"
              strokeLinecap="round"
            />
            <path
              d="M16.318 20c2.085 0 2.266-1.059 4.158-1.059 1.891 0 2.12 1.059 4.206 1.059"
              strokeLinecap="square"
            />
            <path d="M20.5 16.294v.53" strokeLinecap="round" />
          </g>
        );
      default:
        return null;
    }
  }

  render() {
    const { type, ...props } = this.props;

    const viewBox = this.VIEWBOX[type];

    return (
      <Icon viewBox={viewBox} {...props}>
        {this.renderPaths(type)}
      </Icon>
    );
  }
}
